<template>
  <div>
    <v-dialog
      v-model="dialog_calendar_setting"
      scrollable
      persistent
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>Calendar Settings</v-card-title>
        <v-card-text>
          <v-card class="pt-4">
            <v-card-title class="justify-center main-title pb-0"
              >All Calendar</v-card-title
            >

            <v-data-table
              :headers="calendar_headers"
              :items="calendar_list"
              :class="
                $vuetify.breakpoint.xsOnly
                  ? 'setting-table-footer-rowperpages'
                  : ''
              "
            >
              <!-- dialog -->
              <template v-slot:top>
                <v-col align="right" v-if="!mobile">
                  <v-btn
                    @click="dialog = true"
                    color="primary"
                    dark
                    class="btn-responsive"
                  >
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>New Calendar
                  </v-btn>
                </v-col>

                <v-dialog
                  v-model="dialog"
                  persistent
                  content-class="alldialog_settings"
                >
                  <v-card>
                    <v-form ref="form" @submit.prevent="save()">
                      <v-card-title>
                        <span class="main-subtitle pb-2">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text class="pb-0 pt-2">
                        <v-text-field
                          v-model="person_position_name"
                          label="Picture File"
                          :rules="rule_position_name"
                          outlined
                        ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="close"
                          >Cancel</v-btn
                        >
                        <v-btn color="primary" type="submit" text>Save</v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </template>
              <!-- detail in dataTable -->
              <template v-slot:item.no="{ item }"
                >{{ calendar_list.indexOf(item) + 1 }}.</template
              >
              <template v-slot:item.action="{ item }">
                <v-btn icon @click="editPersonPositionName(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="deleteData(item.positionId)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-btn
              class="ma-2 d-block d-sm-none"
              fab
              color="secondary"
              bottom
              dark
              fixed
              right
              @click="dialog = !dialog"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog_calendar_setting = false"
            >cancel</v-btn
          >
          <v-btn color="success" @click="dialog_calendar_setting = false"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog_calendar_setting: false,
      dialog: false,
      calendar_headers: [
        {
          text: "No.",
          value: "no",
          sortable: false,
          align: "center",
          width: "20%"
        },
        {
          text: "Picture File",
          value: "picturefile",
          sortable: false,
          align: "left",
          width: "60%"
        },
        {
          text: "Actions",
          value: "action",
          sortable: false,
          align: "center",
          width: "20%"
        }
      ],
      calendar_list: []
    };
  },
  methods: {
    openSetting() {
      this.dialog_calendar_setting = true;
    },
    close() {
      this.dialog = false;
      // this.person_positions_id = "";
      // this.person_position_name = "";
      this.editedIndex = -1;
      this.clear();
    },

    save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.putData();
          this.close();
        } else {
          this.postData();
          this.close();
        }
      }
    }
  }
};
</script>
